import { render, staticRenderFns } from "./Memos.vue?vue&type=template&id=3cabc202&scoped=true"
import script from "./Memos.vue?vue&type=script&lang=js"
export * from "./Memos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cabc202",
  null
  
)

export default component.exports